// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import RoundedIncrement from '../_raw/ui/icon_rounded_increment.svg';
import withIconProps from '../withIconProps';

export default withIconProps(RoundedIncrement);
